import { Controller, useFormContext } from 'react-hook-form';

import { createPhoneGroupHandlers } from '@/components/Form/FormPhoneNumberField/createPhoneGroupHandlers';
import { FormPhoneNumberField } from '@/components/Form/FormPhoneNumberField/FormPhoneNumberField';
import type { ItemFieldDef } from '@/core/dcr/fields/types';

import { useFieldLabel } from '../_hooks/useFieldLabel';
import { hasValue } from '../_utils/hasValue';

type Props = {
	name: string;
	isoName: string;
	def: ItemFieldDef;
};

export const PhoneItemInput = ({ name, isoName, def }: Props) => {
	const { control, setValue, getValues } = useFormContext();
	const fieldLabel = useFieldLabel();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field: phoneField, fieldState }) => (
				<Controller
					name={isoName}
					control={control}
					render={({ field: isoField }) => (
						<FormPhoneNumberField
							id={name}
							name={name}
							label={fieldLabel(def)}
							countryIso={(isoField.value as string | undefined) ?? ''}
							phoneValue={(phoneField.value as string | undefined) ?? ''}
							{...createPhoneGroupHandlers(
								setValue,
								getValues,
								{
									name,
									value: phoneField.value ?? '',
									onChange: phoneField.onChange
								},
								{
									name: isoName,
									value: isoField.value ?? '',
									onChange: isoField.onChange
								}
							)}
							errorMessage={fieldState.error?.message}
							indicateError={!!fieldState.error}
							isDirty={hasValue(phoneField.value)}
						/>
					)}
				/>
			)}
		/>
	);
};
